import * as React from "react";
import PageLayout from "../components/Shared/PageLayout";
import dynamic from "next/dynamic";
import { EDPageLoader } from "@trailblazer-game/ed-webkit";

const Mint = dynamic(() => import("../components/Pages/Mint/Private/Mint"), {
    suspense: false,
    ssr: false,
    loading: () => <EDPageLoader in={true}/>,
})

export default function MintPage() {
    return <PageLayout title={"Mint"} backgroundImage={"/mint/Nesting_01.jpg"} backgroundColor={"rgba(0,0,0,0.5)"}>
        <Mint/>
    </PageLayout>;
}

MintPage.metaData = {
    title: 'Eternal Dragons Universe - Mint'
}